<ix-layout-grid class="h-100 d-flex flex-column">
  <ix-pane
    (expandedChanged)="onPassListDetailPaneChanged($event)"
    [expanded]="passListDetailsPaneExpanded"
    class="position-fixed end-0 detail-pane"
    composition="right"
    [heading]="'battery_pass.list.passport_details' | translate"
    [hideOnCollapse]="true"
    variant="floating">
    <app-pass-list-details
      (eventClick)="onDetailEventClick()"
      (removeClick)="onRemovePassportClick(selectedPassport)"
      [passport]="selectedPassport"
    [schemas]="schemas"></app-pass-list-details>
  </ix-pane>

  <ix-row>
    <ix-col>
      <ix-content-header
        headerTitle="{{ 'overview.menu.find_passports' | translate }}"
        id="ecoSystemSubHeader">
        <ix-button
          (click)="addNewPassportClick()"
          *ngxPermissionsOnly="['DATA_MANAGER']"
          icon="plus"
          id="overviewAddPassportButton"
          onkeypress=""
          variant="secondary">
          {{ 'battery_pass.create.workflow' | translate }}
        </ix-button>
      </ix-content-header>
    </ix-col>
  </ix-row>

  @if (loading) {
    <ix-row>
      <ix-col class="d-flex justify-content-center">
        <ix-spinner size="large"></ix-spinner>
      </ix-col>
    </ix-row>
  }

  @if (!loading) {
    <ix-row class="flex-grow-1">
      <ix-col class="h-100 search-bar">
        <app-side-bar-search
          [schemas]="schemas"
          [numberOfFoundPassports]="totalElements"
          [initialSearchCriteria]="initialSearchCriteria"
          (searchChange)="onSearchCriteria($event)">
        </app-side-bar-search>
      </ix-col>
      <ix-col class="overflow-auto">
        <div [class.empty-dataset]="!totalElements && !loading"
          class="ag-grid-container">
          <ag-grid-angular
            [columnDefs]="columnDefs"
            [gridOptions]="gridOptions"
            [suppressCellFocus]="true"
            [getRowClass]="getRowClass.bind(this)"
            (gridReady)="onGridReady($event)"
            (cellClicked)="onCellClicked($event)"
            class="w-100 h-100">
          </ag-grid-angular>
        </div>
        @if (!totalElements && !loading) {
          <ix-empty-state
            class="mt-3"
            (actionClick)="addNewPassportClick()"
            action="{{ 'battery_pass.create.workflow' | translate }}"
            header="{{ 'battery_pass.list.no_passport_available' | translate }}"
            icon="anomaly-none"
            subHeader="{{'battery_pass.list.no_passport_found_subtitle' | translate}}">
          </ix-empty-state>
        }
      </ix-col>
    </ix-row>
  }
</ix-layout-grid>

